import {jQuery as $, lodash as _} from 'lib/shim';

import {generateObjectFitCallback} from 'util/objectfit';
import {waitForRepaint} from 'util/dom';



const NAME = 'organism-breakout-image-tab-teaser',
	SELECTOR = '.'+NAME;


class OrganismBreakoutImageTabTeaser {

	constructor(app, $element){
		if( !$.isSet($element.dataDuo('primed')) ){
			$element.dataDuo('primed', true);

			this._app = app;
			this._id = $.randomUuid(true);
			this._$element = $element;

			this._$mobileVersion = this._$element.find('.mobile-version').first();
			this._$sliderMobile = this._$mobileVersion.find('.image-slider').first();
			this._$slickTrackMobile = $();
			this._$slickSlidesMobile = $();
			this._$silderImgsMobile = $();
			this._$tabletDesktopVersion = this._$element.find('.tablet-desktop-version').first();
			this._$sliderTabletDesktop = this._$tabletDesktopVersion.find('.image-slider').first();
			this._$slidesTabletDesktop = this._$sliderTabletDesktop.find('.slide');
			this._$silderImgsTabletDesktop = this._$sliderTabletDesktop.find('picture > img');
			this._$teasersTabletDesktop = this._$tabletDesktopVersion.find('.teasers > .teaser');

			this._refreshCallbacks = [];
			this._sliderMobileReady = $.Deferred();
			this._sliderTabletDesktopReady = $.Deferred();

			this._prime();
		}

		return $element;
	}



	_prime(){
		let _this_ = this;

		this._$mobileVersion.addClass('ready');
		waitForRepaint(() => {
			this._$sliderMobile
				.on('init', () => {
					this._$slickTrackMobile = this._$sliderMobile.find('.slick-track').first();
					this._$slickSlidesMobile = this._$slickTrackMobile.find('.slick-slide');
					this._$silderImgsMobile = this._$sliderMobile.find('picture > img');

					this._$silderImgsMobile.each(function(){
						_this_._refreshCallbacks.push(generateObjectFitCallback({
							callbackHandler : function(cb){ return cb; },
							$element : $(this),
							containerSelector : 'figure',
							position : {
								'top' : '50%',
								'left' : '50%'
							}
						}));
					});

					this._refreshCallbacks.push(_.debounce(() => {
						this._$slickSlidesMobile.css('height', '');

						waitForRepaint(() => {
							this._$slickSlidesMobile.css('height', this._$slickTrackMobile.outerHeight());
						});
					}, 500));

					this._sliderMobileReady.resolve();
				})
				.on('afterChange', (e, slick, currentSlide) => {
					this._$teasersTabletDesktop.eq(currentSlide).triggerHandler('click');
				})
				.slick({
					infinite : false,
					appendDots : this._$sliderMobile,
					dots : true,
					arrows : false,
					mobileFirst: true,
					slidesToShow: 1,
					slidesToScroll: 1
				})
			;
		});


		this._$silderImgsTabletDesktop.each(function(){
			_this_._refreshCallbacks.push(generateObjectFitCallback({
				callbackHandler : function(cb){ return cb; },
				$element : $(this),
				containerSelector : 'figure',
				position : {
					'top' : '50%',
					'left' : '50%'
				}
			}));
		});


		this._$teasersTabletDesktop
			.on('click', function(e){
				e.preventDefault();

				let index = $(this).index();

				_this_._$slidesTabletDesktop
					.removeClass('active')
					.eq(index)
						.addClass('active')
					.end()
				;

				_this_._$teasersTabletDesktop.removeClass('active');
				$(this).addClass('active');

				if( _this_._sliderMobileReady.state() === 'resolved' ){
					_this_._$sliderMobile.slick('slickGoTo', index, true);
				}
			})
			.find('a')
				.on('click', function(e){
					e.stopPropagation();
				})
			.end()
		;


		this._app.registerResizeCallback(NAME+'-resize-'+this._id, () => {
			this._refresh();
		});
		this._refresh(() => {
			this._sliderTabletDesktopReady.resolve();
		});


		$.when(this._sliderMobileReady, this._sliderTabletDesktopReady).done(() => {
			this._$element.removeClass('cloaked');
			this._refresh();
		});
	}



	_refresh(afterRefreshCallback){
		afterRefreshCallback = $.orDefault(afterRefreshCallback, $.noop);

		waitForRepaint(() => {
			_.each(this._refreshCallbacks, (cb) => { cb(); });
			afterRefreshCallback();
		});
	}
}



export function init(app){
	let $elements = $();

	$(SELECTOR).each(function(){
		let $this = $(this);

		$elements = $elements.add(new OrganismBreakoutImageTabTeaser(app, $this));
	});

	return $elements;
}
